import { render } from "./Resolutions.vue?vue&type=template&id=a1269878&scoped=true"
import script from "./Resolutions.vue?vue&type=script&lang=js"
export * from "./Resolutions.vue?vue&type=script&lang=js"

import "./Resolutions.vue?vue&type=style&index=0&id=a1269878&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a1269878"

export default script